import { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import VueRouter from "./VueRouter";
import store from "../store";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/planos",
    name: "HomeB",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/out",
    name: "Out",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register",
    name: "NewRegister",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-cpf",
    name: "NewRegisterCpf",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/forgotpwd-cpf",
    name: "ForgotPwdCpf",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/forgotpwd",
    name: "ForgotPwdPassword",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/forgotpwd-email",
    name: "ForgotPwdEmail",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/forgotpwd-token",
    name: "ForgotPwdToken",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/initial-login",
    name: "InitialLogin",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/deep-link",
    name: "DeepLink",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/deep-link-mgm",
    name: "DeepLinkMgm",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/ncnd-link",
    name: "NcndLink",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-address",
    name: "NewRegisterAddress",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-confirm",
    name: "NewRegisterConfirm",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-phone",
    name: "NewRegisterPhone",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-sms",
    name: "NewRegisterSms",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-balance",
    name: "NewRegisterBalance",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-resume",
    name: "NewRegisterResume",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-sms-portability",
    name: "NewRegisterSmsPortability",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-success-portability",
    name: "NewRegisterSuccessPortability",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/new-register-success",
    name: "NewRegisterSuccess",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/flex-promo",
    name: "FlexPromo",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      publicAccess: true,
    },
  },
  {
    path: "*",
    redirect: "/",
    meta: {
      publicAccess: true,
    },
  },
].map((route: RouteConfig) => ({
  component: () =>
    import(/* webpackChunkName: "[request]" */ `../views/${route.name}.vue`),
  ...route,
}));

const router = VueRouter(routes, store);
router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
  if (
    to.name !== "CompleteProfile" &&
    store.getters.currentUser &&
    !store.getters.hasCompletedProfile
  ) {
    return next({ name: "CompleteProfile" });
  }
  if (to.name === "DeepLinkMgm") {
    const url = new URL(window.location.href);
    const URL_INVITE_PARAM = "invite";
    const inviteToken = url.searchParams.get(URL_INVITE_PARAM);
    if (inviteToken && navigator.userAgent.match(/Android/i)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=br.com.claro.flex&hl=pt_BR&referrer=invite%3D".concat(
          inviteToken
        );
    }
  }
  if (to.name === "NcndLink") {
    const url = new URL(window.location.href);
    const URL_INVITE_PARAM = "invite";
    const inviteToken = url.searchParams.get(URL_INVITE_PARAM);
    if (inviteToken && navigator.userAgent.match(/Android/i)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=br.com.claro.flex&hl=pt_BR&referrer=invite%3D".concat(
          inviteToken
        );
    }
  }
  return next();
});

export default router;
